import styled from 'styled-components';
import BaseIconSvg from '@sdk/components/ui/BaseIconSvg';

import CloseSVG from '@web/assets/svg/UI/close.svg';
import {
  CONVERSATION_LEFT_PADDING,
  CONVERSATION_RIGHT_PADDING,
} from '@web/conversations/consts/layout';

export const CloseIcon = styled(BaseIconSvg)``;
CloseIcon.defaultProps = {
  as: CloseSVG,
};

export const Button = styled.button`
  background: transparent;
  border: 0;
  border-radius: 0;
  color: ${({ theme }) => theme.colors.iconGray};
  cursor: pointer;
  display: block;
  height: 24px;
  width: 24px;
  padding: 0;
  position: absolute;
  right: 3px;
  top: 3px;
  transition:
    color 0.25s ease,
    opacity 0.25s ease;
  opacity: 0.65;

  &:hover {
    opacity: 1;
  }
`;

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.bodyBg};
  inset: auto ${CONVERSATION_RIGHT_PADDING}px 100% ${CONVERSATION_LEFT_PADDING}px;
  padding: 5px 20px 10px 10px;
  position: absolute;
`;
